import { render } from "./AppList.vue?vue&type=template&id=6ce3b854"
import script from "./AppList.vue?vue&type=script&lang=ts"
export * from "./AppList.vue?vue&type=script&lang=ts"
script.render = render

export default script